/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiCSVErrorFromJSON, ApiCSVErrorToJSON, } from './ApiCSVError';
import { ApiCSVFieldFromJSON, ApiCSVFieldToJSON, } from './ApiCSVField';
export function ApiCSVRuleFromJSON(json) {
    return ApiCSVRuleFromJSONTyped(json, false);
}
export function ApiCSVRuleFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'availableErrors': !exists(json, 'availableErrors') ? undefined : (json['availableErrors'].map(ApiCSVErrorFromJSON)),
        'dateGroupingRequired': !exists(json, 'dateGroupingRequired') ? undefined : json['dateGroupingRequired'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'fields': !exists(json, 'fields') ? undefined : (json['fields'].map(ApiCSVFieldFromJSON)),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'uniqueIndex': !exists(json, 'uniqueIndex') ? undefined : json['uniqueIndex'],
        'warning': !exists(json, 'warning') ? undefined : json['warning'],
    };
}
export function ApiCSVRuleToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'availableErrors': value.availableErrors === undefined ? undefined : (value.availableErrors.map(ApiCSVErrorToJSON)),
        'dateGroupingRequired': value.dateGroupingRequired,
        'description': value.description,
        'fields': value.fields === undefined ? undefined : (value.fields.map(ApiCSVFieldToJSON)),
        'id': value.id,
        'uniqueIndex': value.uniqueIndex,
        'warning': value.warning,
    };
}
